// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__2BOTy","info":"UpdateTermsInfo_info__1Z6o8"};